module.exports = __webpack_public_path__ + "img/box-05.ab4048c6.jpg";